export const locKeys = {
  flightRoundTripText: "wizard.flight.roundTrip.text",
  flightOneWayText: "wizard.flight.oneway.withHyphen.text",
  flightMultiCityText: "wizard.flight.multiCity.withHyphen.sentenceCase.text",
  flightOneTravelerText: "wizard.roomPicker.singleTraveler",
  flightMultiTravelersText: "wizard.roomPicker.multipleTravelers",
  showMoreText: "recentSearches.mobile.collapsedButton",
  showLessText: "recentSearches.mobile.expandedButton",
  perTravelerText: "recentSearches.perTraveler",
  perAdultText: "destinationActivities.perAdult",
  perNightText: "hotels.price.perNight",
  keepPlanningText: "recentSearches.title",
  getRatesText: "recentSearches.nonPrice",
};
